/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Share_Copy_FailedInputs */

const en_notes_v2_share_copy_failed = /** @type {(inputs: Notes_V2_Share_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy the note`)
};

const es_notes_v2_share_copy_failed = /** @type {(inputs: Notes_V2_Share_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo copiar la nota`)
};

/**
* | output |
* | --- |
* | "Could not copy the note" |
*
* @param {Notes_V2_Share_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_share_copy_failed = /** @type {((inputs?: Notes_V2_Share_Copy_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Share_Copy_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_share_copy_failed(inputs)
	return en_notes_v2_share_copy_failed(inputs)
});